// extracted by mini-css-extract-plugin
export default {"wrapper":"PageTeams_wrapper__iBzvV","select":"PageTeams_select__SQBTO"};